import * as i0 from '@angular/core';
import * as i1 from './calendar.module';
import * as i2 from './base-calendar.component';
import * as i3 from './calendar.component';
import * as i4 from './base-calendar.module';
export const ElCalendarModuleNgFactory:i0.NgModuleFactory<i1.ElCalendarModule> = (null as any);
var _decl0_0:i2.ElBaseCalendarComponent<any,any> = (<any>(null as any));
var _decl0_1:i3.ElCalendarComponent<any> = (<any>(null as any));
var _decl0_2:i4.ElBaseCalendarModule = (<any>(null as any));
var _decl0_3:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_4:i0.ElementRef<any> = (<any>(null as any));
function _View_ElCalendarComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_1.boundingMonth;
  currVal_0;
  const currVal_1:any = _decl0_1.startView;
  currVal_1;
  const currVal_2:any = _decl0_1.min;
  currVal_2;
  const currVal_3:any = _decl0_1.max;
  currVal_3;
  const currVal_4:any = _decl0_1.filter;
  currVal_4;
  const currVal_5:any = _decl0_1.dayCellComponent;
  currVal_5;
  const currVal_6:any = _decl0_1.monthCellComponent;
  currVal_6;
  const currVal_7:any = _decl0_1.yearCellComponent;
  currVal_7;
  const currVal_8:any = _decl0_1.size;
  currVal_8;
  const currVal_9:any = _decl0_1.visibleDate;
  currVal_9;
  const currVal_10:any = _decl0_1.showHeader;
  currVal_10;
  const currVal_11:any = _decl0_1.date;
  currVal_11;
  const currVal_12:any = _decl0_1.showWeekNumber;
  currVal_12;
  const currVal_13:any = _decl0_1.weekNumberSymbol;
  currVal_13;
  const currVal_14:any = _decl0_0.showWeekNumber;
  currVal_14;
  const currVal_15:any = _decl0_0.medium;
  currVal_15;
  const currVal_16:any = _decl0_0.large;
  currVal_16;
  const pd_17:any = ((<any>_decl0_1.dateChange.emit(_any)) !== false);
}
